import { css } from "@emotion/react"
import styled from "@emotion/styled"
import { ReactNode, useState } from "react"
import "swiper/css/bundle"
import { Navigation } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"
import Shared from "theme/shared"

export const SliderButtonsPositioned = (p) => css`
  .nextEl {
    /*! @noflip */
    right: -90px;
  }
  .prevEl {
    /*! @noflip */
    left: -90px;
  }

  .nextEl,
  .prevEl {
    color: ${p.theme.colors.white};
    position: absolute;
    z-index: 1000;
    margin: 0;
    padding: 25px;
  }

  .slider {
    ${p.theme.breakpoints.down("sm")} {
      padding: 0;
    }
  }
`

const Styled = {
  Grid: styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    position: relative;
  `,
  Slider: styled.div`
    flex: 1;
    max-width: 1280px;
    overflow: hidden;
    ${(p) => p.theme.breakpoints.down("sm")} {
      padding: 0 34px;
      .swiper {
        overflow: visible;
      }
    }
  `,
}

type SliderProps<T> = {
  slidesPerView?: number
  spaceBetween?: number
  loop?: boolean
  data: T[]
  prefix: string
  render: (item: T) => ReactNode
  renderSection?: (item: T) => ReactNode
}

function Slider<T>({
  slidesPerView = 1,
  spaceBetween = 0,
  data,
  loop = false,
  render,
  renderSection,
  prefix,
}: SliderProps<T>) {
  const [active, setActive] = useState<T>(data[0])
  const nextEl = prefix + "-nextEl"
  const prevEl = prefix + "-prevEl"
  const visible = data.length > slidesPerView
  return (
    <>
      <Styled.Grid>
        <Shared.ButtonNext visible={visible} className={`${nextEl} nextEl`} />
        <Styled.Slider className="slider">
          <Swiper
            modules={[Navigation]}
            spaceBetween={spaceBetween}
            navigation={{ nextEl: `.${nextEl}`, prevEl: `.${prevEl}` }}
            slidesPerView={slidesPerView}
            loop={loop}
            // loopAdditionalSlides={loop ? data.length : 0}
            centeredSlides
            centeredSlidesBounds
            centerInsufficientSlides
            resistanceRatio={0}
            grabCursor
            onSlideChange={(swiper) => setActive(data[swiper.realIndex])}
            // initialSlide={0}
          >
            {data.map((item, i) => (
              <SwiperSlide key={i}>{render(item)}</SwiperSlide>
            ))}
          </Swiper>
        </Styled.Slider>
        <Shared.ButtonPrev visible={visible} className={`${prevEl} prevEl`} />
      </Styled.Grid>
      {active && renderSection && renderSection(active)}
    </>
  )
}

export default Slider
